import OverlayRootState from "layout/models/redux-state.interface";
import { MenuLink, SubMenuLink } from "blocks/models/menu-link.interface";
import isBrowserContext from "../../helpers/isBrowserContext";

export default (item: MenuLink | SubMenuLink, styles: any, overlay?: OverlayRootState): string | undefined => {
    const result = [];
    if (!item || !item.content) {
        return undefined;
    }

    const itemLink = item.content.link;

    // Active Dropdown
    if (
        overlay &&
        overlay.currentOverlay === "MEGA_DROPDOWN_MENU" &&
        overlay.content?.content.link === itemLink &&
        overlay.content?.content.label === item.content.label
    ) {
        result.push(styles.is_open);
    }

    // Active First Level
    if (isBrowserContext() && itemLink && window.location.href === itemLink) {
        result.push(styles.is_active);
    }

    // Active Second Level
    if (isBrowserContext() && item.content._contentType === "internalMenuLink") {
        const hasActiveChild = item.content.subMenu?.find((subItem) => {
            return subItem.content?.link === window.location.href;
        });

        if (hasActiveChild) {
            result.push(styles.has_active_child);
        }
    }

    return result.length > 0 ? result.join(" ") : undefined;
};
